import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { DashboardClaim } from '@lsq-frontend/remote-services/enterprise/common';
import { Color, IClaims, Orientation } from '@lsq-frontend/common-ui';
import { Icons } from '@lsq-frontend/common-ui';
import { ManageUsersService } from '../../services/manage-users.service';
import { IPermissionsUiControl, ManageContactState } from '../../settings/settings.models';

@Component({
    selector: 'permissions',
    templateUrl: './permissions.component.html',
    styleUrls: ['./permissions.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class PermissionsComponent {
    @Input() public readOnly = true;
    @Input('modal') public isModal = false;
    @Input('newUser') public isNewUser = false;
    @Input() public allOff = false;
    @Output() public claimsChange = new EventEmitter<IClaims>();

    // Constants.
    public orientation = Orientation;
    public icons = Icons;
    public color = Color;

    constructor(private _manageUsersService: ManageUsersService) {}

    public ngOnInit(): void {
        if (this.allOff) {
            this._manageUserState.standardPermissionsUiControls.forEach((permisson) => {
                permisson.isOn = false;
            });
            this._manageUserState.adminPermissionsUiControls.forEach((permisson) => {
                permisson.isOn = false;
            });
        } else {
            this._updatePermissionControlReadOnlyFlags();
        }
    }

    public get standardPermissionsUiControls(): IPermissionsUiControl[] {
        return this._manageUserState.standardPermissionsUiControls || [];
    }

    public get adminPermissionsUiControls(): IPermissionsUiControl[] {
        return this._manageUserState.adminPermissionsUiControls || [];
    }

    public hasClaims(claims: DashboardClaim[]): boolean {
        return (
            !!this._manageUserState.claims &&
            !this.allOff &&
            claims &&
            claims.every((claim) => this._manageUserState.claims.indexOf(claim) >= 0)
        );
    }

    public handleClaimsChange(): void {
        if (!this.allOff) {
            this.claimsChange.emit(
                this._manageUsersService.getClaimsFromUiControls({
                    admin: this.adminPermissionsUiControls,
                    standard: this.standardPermissionsUiControls
                })
            );

            this._updatePermissionControlReadOnlyFlags();
        }
    }

    public isSwitchDisabled(permissionControl: IPermissionsUiControl): boolean {
        return this.readOnly || !!permissionControl.isReadOnly || permissionControl.isDisabled;
    }

    private _updatePermissionControlReadOnlyFlags(): void {
        [...this.adminPermissionsUiControls, ...this.standardPermissionsUiControls].forEach(
            (permissionControl) => {
                // Find if this claim is an add-on for another claim.
                permissionControl.isReadOnly = [
                    ...this.adminPermissionsUiControls,
                    ...this.standardPermissionsUiControls
                ].some(
                    (permissionControlToCheck) =>
                        !!permissionControlToCheck.isOn &&
                        permissionControlToCheck.addOnClaims &&
                        permissionControlToCheck.addOnClaims.some(
                            (addOnClaim) => permissionControl.claims.indexOf(addOnClaim) >= 0
                        )
                );

                if (permissionControl.isReadOnly) {
                    permissionControl.isOn = true;
                }
            }
        );
    }

    private get _manageUserState(): ManageContactState {
        return this.isNewUser
            ? this._manageUsersService.addUserState
            : this._manageUsersService.activeManageUserState;
    }
}
